export default __webpack_public_path__ + "static/apple-podcasts-badge-2d8519bd647b00d1842df721e6000ab1.svg";